import axios from 'axios';
import {
  useEffect, useMemo, useState,
} from 'react';
import AsyncSelect from 'react-select/async';
import { axiosMicro } from '~/services';
import { CustomSelectInput } from '../CustomSelectInput';

function fetchData(config, params = {}) {
  return new Promise((resolve, reject) => {
    if (/^https?:\/\//.test(config.path)) {
      return axios.get(config.path, {
        params,
      }).then((json) => resolve(json.data))
        .catch((err) => reject(err));
    }

    return axiosMicro.get(config.path, {
      params,
    }).then((json) => resolve(json.data))
      .catch((err) => reject(err));
  });
}

function parseData(json, object, config) {
  try {
    if (object.length > 1) {
      return parseData(json[object[0]], object.slice(1), config);
    }

    return json[object[0]].map((item, index) => ({
      value: item[config.value].toString(),
      label: item[config.title],
      key: index,
    }));
  } catch {
    return [];
  }
}

function debounce(fn, delay) {
  let timer = null;

  return (value, callback) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn(value, callback);
    }, delay);
  };
}

export const SelectApi = ({
  name,
  config,
  value,
  onChange,
}) => {
  const [selected, setSelected] = useState(null);
  const option = useMemo(() => {
    if (!config || !config.path || !config.object || !config.value || !config.title) {
      return null;
    }

    return config;
  }, [config]);

  useEffect(() => {
    if (value) {
      if (value !== selected?.value) {
        fetchData(option, { [option.value]: value }).then(async (res) => {
          const list = await parseData(res, option.object.split('.'), option);
          if (list.length) {
            setSelected(list[0]);
          }
        });
      }
    } else {
      setSelected(null);
    }
  }, [value]);

  if (!option) {
    return null;
  }

  const handleChange = (val) => {
    setSelected(val);
    onChange(val.value);
  };

  const promiseOptions = debounce((search, callback) => {
    fetchData(option, { [option.title]: search }).then(async (res) => {
      const list = await parseData(res, option.object.split('.'), option);
      callback(list);
    });
  }, 500);

  return (
    <AsyncSelect
      name={name}
      components={{ Input: CustomSelectInput }}
      className="react-select"
      classNamePrefix="react-select"
      cacheOptions
      defaultOptions
      value={selected}
      loadOptions={promiseOptions}
      onChange={handleChange}
    />
  );
};
